module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [(_vm.$slots.head) ? _c('el-card', {
    staticClass: "card__head op_card_head",
    attrs: {
      "shadow": "never"
    }
  }, [
    [_vm._t("head")]
  ], 2) : _vm._e(), _vm._v(" "), (_vm.$slots.content) ? _c('el-card', {
    staticClass: "card__content",
    attrs: {
      "shadow": "never"
    }
  }, [
    [_vm._t("content")]
  ], 2) : _vm._e(), _vm._v(" "), (_vm.$slots.foot) ? _c('el-card', {
    staticClass: "card__foot",
    attrs: {
      "shadow": "never"
    }
  }, [
    [_vm._t("foot")]
  ], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a30d374"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Card/index.vue
// module id = 2419
// module chunks = 68